import React, { useState } from 'react';
import { useTranslator } from 'tradera/lang/translate';
import { ReplyFeedbackModal } from './reply-feedback-modal';

export const ReplyButton = ({ feedbackItem }) => {
    const { t } = useTranslator();
    const [openReplyFeedbackModal, setOpenReplyFeedbackModal] = useState(false);

    return (
        <>
            <button
                className="btn btn-primary"
                onClick={() => setOpenReplyFeedbackModal(true)}>
                {t('profileRating_createComment')}
            </button>
            {openReplyFeedbackModal && (
                <ReplyFeedbackModal
                    feedbackItem={feedbackItem}
                    onClose={() => setOpenReplyFeedbackModal(false)}
                />
            )}
        </>
    );
};
